// Prompt text lives server-side in AiMotionPresets.php; the client only sends a key.
// `anim` selects the CSS hover diagram in SceneAiMotionPopover.vue.
export const AI_MOTION_PRESETS = [
  { key: 'float', label: 'Float', anim: 'float' },
  { key: 'slow-zoom', label: 'Slow zoom', anim: 'zoom' },
  { key: 'parallax', label: 'Parallax', anim: 'pan' },
  { key: 'sparkle', label: 'Sparkle', anim: 'twinkle' },
  { key: 'steam', label: 'Steam', anim: 'steam' },
];

export const CUSTOM_PRESET_KEY = 'custom';

/**
 * Mirror of AiMotionPresets::labelFor(). The finished-clip broadcast already sends the
 * label, but while a clip is still in flight the client only holds the key it sent, and
 * the panel header has to name the preset it is generating (POR-13982).
 */
export function presetLabel(key) {
  if (key === CUSTOM_PRESET_KEY) {
    return 'Custom';
  }

  const preset = AI_MOTION_PRESETS.find(item => item.key === key);

  return preset ? preset.label : key;
}

// AiMotionCreditService::debitSql() always debits exactly 1, so the panel can state the
// cost without a round trip.
export const CREDITS_PER_CLIP = 1;

// POR-13982 specifies the .ai domain for this link; the rest of the app writes
// support@itsrapid.io (see AiMotionController's own out-of-credits message).
export const SUPPORT_EMAIL = 'support@itsrapid.ai';

export const CREDITS_REQUEST_SUBJECT = 'Video credits request';

// Deliberately narrower than VeoRequest::ALLOWED_CLIP_LENGTHS (which still accepts 6 and 8):
// longer clips read as an unfinished loop on a single scene, so the UI only offers 2-5s.
export const CLIP_LENGTHS = [2, 3, 4, 5];

export const DEFAULT_CLIP_LENGTH = 2;

// Measured median across 12 spike clips was 41.8s. The API reports no percentage,
// so the progress bar interpolates against this and waits for the socket event.
export const ESTIMATED_SECONDS = 40;
